module.exports = __webpack_public_path__ + "img/building-img-color3.e1b09a5f.png";